export default __webpack_public_path__ + "static/media/IT.58e75ceb.svg";